import {Component, inject, OnInit} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {AppStateService} from '@app/common/services/app-state.service';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss'],
  imports: [
    TranslatePipe
  ]
})
export class FaqComponent implements OnInit {
  protected readonly appStateService = inject(AppStateService);

  public yearsOfExperiance = 1;

  constructor() {
  }

  ngOnInit() {
    this.yearsOfExperiance = this.calculateAge(new Date('2019'));
  }

  private calculateAge(birthday: any) { // birthday is a date
    const ageDifMs = Date.now() - birthday;
    const ageDate = new Date(ageDifMs); // miliseconds from epoch
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  }

}
